import { motion } from "framer-motion";
import { ArrowUpRight, ArrowDownRight, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AnimatedBalance } from "./animated-balance";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface BalanceCardProps {
  balance: number;
  onTopUp?: () => void;
  onSend?: () => void;
  showActions?: boolean;
  className?: string;
}

export function BalanceCard({
  balance,
  onTopUp,
  onSend,
  showActions = true,
  className,
}: BalanceCardProps) {
  const [showBalance, setShowBalance] = useState(true);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={className}
    >
      <Card className="border-2 bg-gradient-to-br from-primary/10 via-purple-500/5 to-transparent overflow-hidden">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div>
              <p className="text-sm text-muted-foreground mb-1">Your Balance</p>
              {showBalance ? (
                <AnimatedBalance value={balance} size="lg" />
              ) : (
                <div className="text-4xl font-bold">••••••</div>
              )}
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setShowBalance(!showBalance)}
              className="h-8 w-8"
            >
              {showBalance ? (
                <Eye className="h-4 w-4" />
              ) : (
                <EyeOff className="h-4 w-4" />
              )}
            </Button>
          </div>

          {showActions && (
            <div className="flex gap-2">
              <Button
                size="lg"
                onClick={onTopUp}
                className="flex-1 bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
              >
                <ArrowDownRight className="h-5 w-5 mr-2" />
                Top Up
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={onSend}
                className="flex-1"
                disabled
              >
                <ArrowUpRight className="h-5 w-5 mr-2" />
                Send
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
